import initialState from './initialState';
import { SET_SUBSCRIPTION_ID } from './actionTypes';

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SUBSCRIPTION_ID:
      return payload.subscriptionId;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/Authentication/reducer.js